import React from 'react';
import { primaryVolumes, secondaryVolumes, Volume } from '../data/content';
type VolumeGroupProps = {
  title: string;
  subtitle: string;
  volumes: Volume[];
};
function VolumeGroup({
  title,
  subtitle,
  volumes
}: VolumeGroupProps) {
  return <div data-id="element-214" data-mp="kvzrbpde9bil">
      <div className="flex items-baseline gap-3" data-id="element-215" data-mp="kyc7bwzldbt0">
        <h3 className="font-display text-xl font-black tracking-tight text-navy" data-id="element-216" data-mp="pu9kxvjh0423">
          {title}
        </h3>
        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-teal" data-id="element-217" data-mp="b5mw937ydzy7">
          {subtitle}
        </span>
      </div>
      <ul className="mt-5 space-y-3" data-id="element-218" data-mp="fz96koqn9rqu">
        {volumes.map(volume => <li key={volume.grade} className="rounded-2xl bg-cream px-5 py-4" data-id="element-219" data-mp="271f9ci4qszj">
            <span className="inline-block rounded-full bg-navy px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-white" data-id="element-220" data-mp="741mvrumo3sr">
              {volume.grade}
            </span>
            <h4 className="mt-2.5 font-display text-base font-bold text-navy" data-id="element-221" data-mp="3tbrr7yjlh30e">
              {volume.title}
            </h4>
            <p className="mt-1 text-xs leading-relaxed text-navy/55" data-id="element-222" data-mp="3csuw0w9veoq9">
              {volume.text}
            </p>
          </li>)}
      </ul>
    </div>;
}
export function WhatsInside() {
  return <section id="contenuto" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-223" data-mp="3luvrbnljn0pa">
      <div className="mx-auto max-w-4xl" data-id="element-224" data-mp="3ht0oufrvmh9x">
        <div className="text-center" data-id="element-225" data-mp="3hubvcncpi34q">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-226" data-mp="3hr65h5w96x7y">
            8 volumi digitali · PDF ad alta risoluzione
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-227" data-mp="2p5wf5xhu9ert">
            <span aria-hidden="true" data-id="element-228" data-mp="32xkppwcfvv6o">🖌️ </span>Cosa trovi dentro il pack{' '}
            <span className="italic text-grape" data-id="element-229" data-mp="2y3qcnbrcaegk">Arte Pronta?</span>
          </h2>
        </div>

        <div className="mt-12 grid gap-10 md:grid-cols-2" data-id="element-230" data-mp="2adma77pw0kr5">
          <VolumeGroup title="Percorso Scuola Primaria" subtitle="5 volumi" volumes={primaryVolumes} data-id="element-231" data-mp="26en61pbzcs0r" />
          <VolumeGroup title="Percorso Scuola Media" subtitle="3 volumi" volumes={secondaryVolumes} data-id="element-232" data-mp="9dzeetbd085b" />
        </div>
      </div>
    </section>;
}